/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { FaAngleDown } from "react-icons/fa";
import LanguageSelector from "./Language/LanguageSelector";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState("Personal");
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <header className=" text-gray-700 bg-black">
      <nav className="container mx-auto flex flex-wrap items-center justify-between w-full py-4 md:py-2 text-lg">
        <div className="flex lg:gap-10 md:gap-4">
          <a href="#" className="lg:w-4/12 md:w-6/12 w-4/12">
            <img src="/assets/images/logo.png" alt="Logo" />
          </a>
          <div className="flex items-center justify-between md:gap-4 gap-2">
            <button
              className={`md:text-sm text-[12px] font-semibold rounded-primary text-white p-2 py-[7px] ${
                type === "Personal" && "bg-primary"
              }`}
              onClick={() => setType("Personal")}
            >
              Personal
            </button>
            <button
              className={`md:text-sm text-[12px] font-semibold rounded-primary text-white p-2 py-[7px]  ${
                type === "Business" && "bg-primary"
              }`}
              onClick={() => setType("Business")}
            >
              Business
            </button>
            <button
              className={`md:text-sm text-[12px] font-semibold rounded-primary text-white p-2 py-[7px]  ${
                type === "Platform" && "bg-primary"
              }`}
              onClick={() => setType("Platform")}
            >
              Platform
            </button>
          </div>
        </div>

        <button
          id="menu-button"
          className="lg:hidden text-white font-bold text-2xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          ☰
        </button>

        <div
          className={`w-full lg:flex lg:items-center lg:w-auto ${
            isOpen ? "" : "hidden"
          }`}
          id="menu"
        >
          <ul className="pt-4 text-base md:flex md:justify-between md:pt-0 items-center">
            <li className="relative">
              <button
                className="md:p-4 py-2 font-semibold text-white  hover:text-primary flex items-center gap-2"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Features <FaAngleDown />
              </button>
              {dropdownOpen && (
                <ul className="absolute top-10 left-0 mt-2 w-48 text-white bg-primary shadow-lg rounded-lg">
                  <li>
                    <a
                      href="#"
                      className="block px-4 py-2 font-semibold hover:bg-black duration-300 text-white"
                    >
                      Feature 1
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="block px-4 py-2 font-semibold hover:bg-black duration-300 text-white"
                    >
                      Feature 2
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className="block px-4 py-2 font-semibold hover:bg-black duration-300 text-white"
                    >
                      Feature 3
                    </a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a
                className="md:p-4 py-2 font-semibold block text-white hover:text-primary"
                href="#"
              >
                Pricing
              </a>
            </li>
            <li>
              <a
                className="md:p-4 py-2 block font-semibold text-white hover:text-primary"
                href="#"
              >
                Help
              </a>
            </li>
            <li className="px-3 border-r-2 border-l-2 h-6">
              
              <LanguageSelector />
            </li>
            <li>
              <a
                className="md:p-4 py-2 block font-semibold text-white hover:text-primary"
                href="#"
              >
                Log in
              </a>
            </li>

            <li>
              <button className="px-4 py-2 block font-semibold bg-primary rounded-primary text-black">
                Register
              </button>
            </li>
            <li>
              <div className="md:hidden flex items-center justify-between gap-4">
                <button
                  className={`text-sm font-semibold rounded-primary text-white p-3 py-[7px] ${
                    type === "Personal" && "bg-primary"
                  }`}
                  onClick={() => setType("Personal")}
                >
                  Personal
                </button>
                <button
                  className={`text-sm font-semibold rounded-primary text-white p-3 py-[7px]  ${
                    type === "Business" && "bg-primary"
                  }`}
                  onClick={() => setType("Business")}
                >
                  Business
                </button>
                <button
                  className={`text-sm font-semibold rounded-primary text-white p-3 py-[7px]  ${
                    type === "Platform" && "bg-primary"
                  }`}
                  onClick={() => setType("Platform")}
                >
                  Platform
                </button>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
